import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import type { ListingFiltersType } from './ListingFiltersProviderContext';

type ListingFiltersProviderProps = PropsWithChildren & {
  listingFiltersType: ListingFiltersType;
};
import { Provider } from './ListingFiltersProviderContext';

export const ListingFiltersProvider = ({
  children,
  listingFiltersType,
}: ListingFiltersProviderProps) => {
  const [data, setData] = useState<ListingFiltersType>(listingFiltersType);
  useEffect(() => {
    setData(listingFiltersType);
  }, [listingFiltersType]);

  return <Provider value={{ listingFiltersType: data }}>{children}</Provider>;
};
